import { elakay_API } from '../../config';

export const getPromotionSummary = async (token, signal) => {
  const response = await fetch(`${elakay_API}/user/promotion-orders/summary`, {
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` }, signal,
  });
  const data = await response.json();
  if (!response.ok || data.success === false) throw Object.assign(new Error(data.code || 'SUMMARY_UNAVAILABLE'), { code: data.code || 'SUMMARY_UNAVAILABLE' });
  return data;
};
